import React, { useState, useEffect } from 'react';
import './ClockBar.css';

const ClockBar: React.FC = () => {
  const [timeNY, setTimeNY] = useState('');
  const [timeITA, setTimeITA] = useState('');
  const [timeCN_SH, setTimeCN_SH] = useState('');
  const [timeSYD, setTimeSYD] = useState('');

  const getTime = (offset: number): string => {
    const localTime = new Date();
    const utc = localTime.getTime() + (localTime.getTimezoneOffset() * 60000);
    const time = new Date(utc + (3600000 * offset));
    return time.toLocaleTimeString('en');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeNY(getTime(-5));    // NY
      setTimeITA(getTime(+1));   // Italia
      setTimeCN_SH(getTime(+8)); // Shanghai
      setTimeSYD(getTime(+11));  // Sydney
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="clock-bar-container d-flex justify-content-around align-items-center" style={{ gap: '20px' }}>
      <div className="clock-text">
        <strong>NY:</strong> {timeNY}
      </div>
      <div className="clock-text">
        <strong>ITA:</strong> {timeITA}
      </div>
      <div className="clock-text">
        <strong>CN-SH:</strong> {timeCN_SH}
      </div>
      <div className="clock-text">
        <strong>SYD:</strong> {timeSYD}
      </div>
    </div>
  );
};

export default ClockBar;
